/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { toastError } from "../../../utils/sysToast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class ChargeRestrictions extends Component {
  state = {
    data: {
      serviceType: "",
      scope: "",
      compoundId: "",
      blockName: "",
      unitId: "",
      isBlocked: false,
      notes: "",
    },

    dataUrl: "/api/data/GetChargeRestrictions",
    addUrl: "/api/data/AddChargeRestriction",
    editUrl: "/api/data/EditChargeRestriction",
    deleteUrl: "/api/data/DeleteChargeRestriction",
    bulkUploadUrl: "/api/data/BulkUploadChargeRestrictions",

    inEditMode: false,
    inModalMode: false,
    modalWidth: "55vw",

    editEntityId: 0,

    bulkUploadModalVisible: false,
    bulkUploadServiceType: "",
    bulkUploadIsBlocked: false,

    compoundsDropdown: [],
    blocksDropdown: [],
    unitsDropdown: [],

    tableData: [],
  };

  fileInputRef = React.createRef();

  getServiceOptions() {
    const { t } = this.props;
    return [{ label: t("col.electricity"), value: 3 }];
  }

  getScopeOptions() {
    const { t } = this.props;
    return [
      { label: t("col.allCompoundsScope"), value: 0 },
      { label: t("col.compound"), value: 1 },
      { label: t("col.block"), value: 2 },
      { label: t("col.unit"), value: 3 },
    ];
  }

  getStatusOptions() {
    const { t } = this.props;
    return [
      { label: t("col.allowed"), value: false },
      { label: t("col.blocked"), value: true },
    ];
  }

  getColumns() {
    const { t } = this.props;
    return [
      { id: 1, field: "SERVICE_NAME", label: t("col.service"), width: "120px" },
      { id: 2, field: "SCOPE_NAME",   label: t("col.scope"),   width: "130px" },
      { id: 3, field: "COMPOUND_NAME", label: t("col.compound") },
      { id: 4, field: "BLOCK_NAME",   label: t("col.block"),   width: "120px" },
      { id: 5, field: "UNIT_NAME",    label: t("col.unit") },
      {
        id: 6,
        field: "STATUS",
        label: t("col.status"),
        width: "110px",
        cellRenderer: ({ data }) => (
          <span style={{ color: data.IS_BLOCKED ? "#DC2626" : "#16A34A", fontWeight: 600 }}>
            {data.IS_BLOCKED ? t("col.blocked") : t("col.allowed")}
          </span>
        ),
      },
      { id: 7, field: "NOTES",           label: t("col.notes") },
      { id: 8, field: "CREATED_BY_NAME", label: t("col.createdBy"), width: "130px" },
      { id: 9, field: "INSERT_DATE",     label: t("col.insertDate"), width: "150px" },
      {
        id: 10,
        field: "SYS_ACTIONS",
        label: t("col.actions"),
        width: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            {sysJwt.isAuthorized(["CB8B"]) && (
              <div className="inner" title={t("btn.edit")}>
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() =>
                    this.getEditFormData(data).then(() => {
                      this.setState({ inEditMode: true });
                      this.showForm();
                    })
                  }
                >
                  <i className="fa fa-edit" />
                </button>
              </div>
            )}
            {sysJwt.isAuthorized(["CB8C"]) && (
              <div className="inner" title={t("btn.delete")}>
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => this.handleDelete(data)}
                >
                  <i className="fa fa-trash" />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getData();
    this.getCompoundsDropdown();
  }

  openBulkUploadDialog() {
    this.setState({ bulkUploadModalVisible: true, bulkUploadServiceType: "", bulkUploadIsBlocked: false });
  }

  closeBulkUploadDialog() {
    this.setState({ bulkUploadModalVisible: false });
  }

  triggerFileInput() {
    const { t } = this.props;
    if (!this.state.bulkUploadServiceType && this.state.bulkUploadServiceType !== 0) {
      toastError(t("col.service") + " " + t("table.filterPlaceholder"));
      return;
    }
    this.closeBulkUploadDialog();
    this.fileInputRef.current.value = "";
    this.fileInputRef.current.click();
  }

  handleFileSelected(e) {
    const { t } = this.props;
    const file = e.target.files[0];
    if (!file) return;
    const ext = file.name.split(".").pop().toLowerCase();
    if (ext !== "xlsx") {
      toastError("Only .xlsx files are allowed");
      return;
    }
    confirmAlert({
      title: t("btn.bulkUpload"),
      message: `${t("btn.chooseFile")}: "${file.name}"`,
      buttons: [
        {
          label: t("btn.yes"),
          onClick: () => {
            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("requestData", JSON.stringify({
              serviceType: this.state.bulkUploadServiceType,
              isBlocked: this.state.bulkUploadIsBlocked,
            }));
            post(this.state.bulkUploadUrl, formData, this.props.updateIsLoading).then(
              (apiResponse) => { if (apiResponse.data.respCode === 0) this.getData(); }
            );
          },
        },
        { label: t("btn.cancel"), onClick: () => null },
      ],
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    if (inputId === "scope") {
      data["compoundId"] = "";
      data["blockName"] = "";
      data["unitId"] = "";
      this.setState({ blocksDropdown: [], unitsDropdown: [] });
    }
    if (inputId === "compoundId" && inputValue) {
      this.getBlocksDropdown(inputValue);
      this.getUnitsDropdown(inputValue);
      data["blockName"] = "";
      data["unitId"] = "";
    }
    this.setState({ data });
  };

  showForm() { this.setState({ inModalMode: true }); }

  closeModal() {
    var data = this.state.data;
    Object.keys(data).forEach((key) => {
      if (key === "isBlocked") data[key] = false;
      else Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });
    this.setState({ inModalMode: false, inEditMode: false, data, editEntityId: 0, blocksDropdown: [], unitsDropdown: [] });
    this.getData();
  }

  getCompoundsDropdown() {
    post("/api/data/GetAllCompoundsDropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ compoundsDropdown: apiResponse.data.respData.data }); }
    );
  }

  getBlocksDropdown(compoundId) {
    post("/api/data/GetBlocksDropdown", { compoundId }, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ blocksDropdown: apiResponse.data.respData.data }); }
    );
  }

  getUnitsDropdown(compoundId) {
    post("/api/data/GetUnitsByCompoundDropdown", { compoundId }, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ unitsDropdown: apiResponse.data.respData.data }); }
    );
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ tableData: apiResponse.data.respData.data }); }
    );
  }

  getEditFormData(row) {
    return new Promise((resolve) => {
      var data = this.state.data;
      data["serviceType"] = row.SERVICE_TYPE;
      data["scope"]       = row.SCOPE;
      data["compoundId"]  = row.COMPOUND_ID ?? "";
      data["blockName"]   = row.BLOCK_NAME ?? "";
      data["unitId"]      = row.UNIT_ID ?? "";
      data["isBlocked"]   = row.IS_BLOCKED;
      data["notes"]       = row.NOTES ?? "";
      const loads = [];
      if (row.COMPOUND_ID) {
        loads.push(this.getBlocksDropdown(row.COMPOUND_ID));
        loads.push(this.getUnitsDropdown(row.COMPOUND_ID));
      }
      Promise.all(loads).then(() => { this.setState({ data, editEntityId: row.ID }); resolve(); });
    });
  }

  handleDelete(row) {
    const { t } = this.props;
    confirmAlert({
      title: t("dialog.deleteTitle"),
      message: t("dialog.deleteConfirm"),
      buttons: [
        {
          label: t("btn.yes"),
          onClick: () =>
            post(this.state.deleteUrl, { id: row.ID }, this.props.updateIsLoading).then(
              (apiResponse) => { apiResponse.data.respCode === 0 ? this.getData() : null; }
            ),
        },
        { label: t("btn.cancel"), onClick: () => null },
      ],
    });
  }

  doSubmit() {
    const submitData = {
      serviceType: this.state.data.serviceType,
      scope:       this.state.data.scope,
      compoundId:  this.state.data.compoundId || null,
      blockName:   this.state.data.blockName || null,
      unitId:      this.state.data.unitId || null,
      isBlocked:   this.state.data.isBlocked,
      notes:       this.state.data.notes || null,
    };
    if (this.state.inEditMode) submitData["id"] = this.state.editEntityId;
    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) { this.props.updateIsLoading(false); this.closeModal(); }
    });
  }

  buildFormFields() {
    const { t } = this.props;
    const { scope } = this.state.data;
    const fields = [
      { type: "dropdown", id: "serviceType", label: t("col.service"), options: this.getServiceOptions() },
      { type: "dropdown", id: "scope",       label: t("col.scope"),   options: this.getScopeOptions() },
    ];
    if (scope === 1 || scope === 2) {
      fields.push({ type: "dropdown", id: "compoundId", label: t("col.compound"), options: this.state.compoundsDropdown });
    }
    if (scope === 2) {
      fields.push({ type: "dropdown", id: "blockName", label: t("col.block"), options: this.state.blocksDropdown });
    }
    if (scope === 3) {
      fields.push({ type: "dropdown", id: "compoundId", label: t("col.compound"), options: this.state.compoundsDropdown });
      fields.push({ type: "dropdown", id: "unitId",     label: t("col.unit"),     options: this.state.unitsDropdown });
    }
    fields.push({ type: "dropdown", id: "isBlocked", label: t("col.status"), options: this.getStatusOptions() });
    fields.push({ type: "text",     id: "notes",     label: t("col.notes") });
    return fields;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.chargeRestrictions")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB8A"]) && (
              <Button
                label={t("btn.addRestriction")}
                icon="fa fa-plus"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => { this.setState({ inEditMode: false }); this.showForm(); }}
              />
            )}
            {sysJwt.isAuthorized(["CB8A"]) && (
              <Button
                label={t("btn.bulkUpload")}
                icon="fa fa-upload"
                className="p-button-rounded p-button-info"
                disabled={this.props.isLoading}
                onClick={() => this.openBulkUploadDialog()}
              />
            )}
            <input
              type="file"
              accept=".xlsx"
              ref={this.fileInputRef}
              style={{ display: "none" }}
              onChange={(e) => this.handleFileSelected(e)}
            />
          </div>
        </div>
        <hr />

        {/* Bulk Upload Settings Dialog */}
        <Dialog
          visible={this.state.bulkUploadModalVisible}
          style={{ width: "35vw" }}
          onHide={() => this.closeBulkUploadDialog()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("pages.bulkUploadSettings")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.chooseFile")}
                icon="fa fa-upload"
                className="p-button-rounded p-button-info"
                disabled={this.props.isLoading}
                onClick={() => this.triggerFileInput()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-times"
                className="p-button-rounded p-button-danger"
                disabled={this.props.isLoading}
                onClick={() => this.closeBulkUploadDialog()}
              />
            </div>
          }
        >
          <div className="form-group">
            <label style={{ display: "block" }}>{t("col.service")}</label>
            <Dropdown
              value={this.state.bulkUploadServiceType}
              options={this.getServiceOptions()}
              showClear={true}
              filter={true}
              className="dropdown"
              onChange={(e) => this.setState({ bulkUploadServiceType: e.value })}
            />
          </div>
          <div className="form-group" style={{ marginTop: "12px" }}>
            <label style={{ display: "block" }}>{t("col.status")}</label>
            <Dropdown
              value={this.state.bulkUploadIsBlocked}
              options={this.getStatusOptions()}
              showClear={false}
              className="dropdown"
              onChange={(e) => this.setState({ bulkUploadIsBlocked: e.value })}
            />
          </div>
        </Dialog>

        {/* Add / Edit Dialog */}
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={() => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={this.state.inEditMode ? "fa fa-edit" : "fa fa-plus"}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-times"
                className="p-button-rounded p-button-danger"
                disabled={this.props.isLoading}
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={this.buildFormFields()}
          />
        </Dialog>

        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(ChargeRestrictions);
